import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { FormTabs } from '@dreryk/react-components';

import visitSettlement from '../../../visitSettlement';
import { VisitFormBean, VisitFormController } from '../visitForm.types';

import { DiagnosesFormTab } from './diagnoses/DiagnosesFormTab';
import { DiagnosesFormTabLabel } from './diagnoses/DiagnosesFormTabLabel';
import { ProceduresFormTab } from './procedures/ProceduresFormTab';
import { ProceduresFormTabLabel } from './procedures/ProceduresFormTabLabel';
import { VisitFormTabsId } from './VisitFormTabs.types';
import { VisitFormTabsChangeTab } from './VisitFormTabsChangeTab';

type VisitFormTabsProps = {
   readonly controller: VisitFormController;
   readonly visit: Visit;
   readonly practitionerId: PractitionerId;
   readonly chronicDiseases: ChronicDiseaseSimple[];
};

export const VisitFormTabs = (props: VisitFormTabsProps): JSX.Element => {
   return (
      <FormTabs<VisitFormBean, VisitFormTabsId>
         testId={'visitFormTabs'}
         formState={props.controller.formState}
         initialActiveTabId={'diagnoses'}
      >
         <FormTabs.Tab
            register={props.controller.register}
            id={'diagnoses'}
            label={() => <DiagnosesFormTabLabel control={props.controller.control} />}
         >
            <DiagnosesFormTab
               register={props.controller.register}
               visitId={props.visit.id}
               dictionaryValidOn={props.visit.beginDate}
               chronicDiseases={props.chronicDiseases}
            />
         </FormTabs.Tab>
         <FormTabs.Tab
            register={props.controller.register}
            id={'procedures'}
            label={() => <ProceduresFormTabLabel control={props.controller.control} />}
         >
            <ProceduresFormTab register={props.controller.register} dictionaryValidOn={props.visit.beginDate} />
         </FormTabs.Tab>
         <>
            <VisitFormTabsChangeTab>
               {({ changeTab }) =>
                  visitSettlement.useVisitSettlementFormTab({
                     appointmentId: props.visit.appointmentId,
                     controller: props.controller,
                     practitionerId: props.practitionerId.asNumber(),
                     visitDetails: {
                        beginDate: props.visit.plannedBeginDate,
                        endDate: props.visit.plannedEndDate,
                        patient: {
                           id: props.visit.patient.id,
                           firstName: props.visit.patient.firstName?.asString() ?? null,
                           lastName: props.visit.patient.lastName?.asString() ?? null,
                        },
                     },
                     onSettlementModalOpen: () => changeTab('visitSettlement'),
                  }) ?? null
               }
            </VisitFormTabsChangeTab>
         </>
      </FormTabs>
   );
};
